export const SHOPS_CUSTOM_CSS = ['03606da4-0052-41ab-81d8-3db9661273af']